<template>
	<TopicTemplate 
		:name="name" 
		:topicImage="topicImage" 
		:title="title"
		:misc="misc"
		:description="getDescriptionText"
		:appointment="appointment"
		:summary="summary"
		:content="content"
		:result="result"
		:selected="selected">
	</TopicTemplate>
</template>
<script>

import AppointmentView from '../../mixin/appointment-view'
import TopicTemplate from './template/TopicTemplate'

export default {
	name: 'appointment_coping_living_question',
	mixins: [ AppointmentView ],
	data() {
		return {
			name: 'coping_living_question',
			topicImage: 'coping_living.png',
			title: 'Coping and Living',
			misc: true
		}
	},
	mounted() {
	},
	computed: {
        getDescriptionText() {
            return `<strong>This section relates to topics you may want to discuss about things you can do to manage your condition better.</strong>`
        }
	},
	components: {
		TopicTemplate
	}
}
</script>

<style lang="scss" scoped>
</style>